import React from 'react';
import { useTypedSelector } from '../hooks/useTypedSelector';
import { Encryptid } from '../store/slices/eidogenSlice';

const EidonomiconPage: React.FC = () => {
  const eidolons = useTypedSelector(state => state.eidogen.encryptids);

  return (
    <div className="flex flex-col h-full">
      <h1>Eidonomicon</h1>
      <table className="w-full border-collapse">
        <thead>
          <tr>
            <th className="border p-2">ID</th>
            <th className="border p-2">Name</th>
            {/* Add more table headers as needed */}
          </tr>
        </thead>
        <tbody>
          {eidolons.map((eidolon: Encryptid) => (
            <tr key={eidolon.id}>
              <td className="border p-2">{eidolon.id}</td>
              <td className="border p-2">{eidolon.name}</td>
              {/* Add more table cells as needed */}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EidonomiconPage;
